import React from 'react'

import { T } from '../../../stores/textStore';

const FIELDS = {
    email: {
        label: 'Email',
        required: false,
        regex: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    },    
    firstname: {
        label: 'First Name',
        required: true,
        regex: null,
    },
    lastname: {
        label: 'Last Name',
        required: true,
        regex: null,
    },
    addr1: {
        label: 'Address Line 1',
        required: true,
        regex: null,
    },
    addr2: {
        label: 'Address Line 2',
        required: false,
        regex: null,
    },
    city: {
        label: 'City',
        required: true,
        regex: null,
    },
    state: {
        label: 'State',
        required: false,
        regex: null,
    },
    zip: {
        label: 'Postal Code',
        required: false,
        regex: null,
    },    
    country: {
        label: 'Country',
        required: true,
        regex: null,        
    },
    mobilephone: {
        label: 'Mobile Phone',
        required: false,
        regex: /(?=^.{7,}$)((?=(.*\w){7,}))^.*$/,
    },
    homephone: {
        label: 'Home Phone',
        required: false,
        regex: /(?=^.{7,}$)((?=(.*\w){7,}))^.*$/,
    },
    ccname: {
        label: 'Name on Card',
        required: true,
        regex: null,
    },
    ccnumber: {
        label: 'Card Number',
        required: true,
        regex: null,
    },
    ccsecuritycode: {
        label: 'Security Code (CVV)',
        required: false,
        regex: /^[0-9]{3,4}$/,
    }, 
    paymentmethod: {
        label: '',
        required: true,
        regex: null,
    },
    ccexpiremonth: {
        label: 'Expiration Month',
        required: true,
        regex: null,
    },
    ccexpireyear: {
        label: 'Expiration Year',
        required: true,
        regex: null,
    },


    shipaddr1: {
        label: 'Address Line 1',
        required: true,
        regex: null,
    },
    shipaddr2: {
        label: 'Address Line 2',
        required: false,
        regex: null,
    },
    shipcity: {
        label: 'City',
        required: true,
        regex: null,
    },
    shipstate: {
        label: 'State',
        required: false,
        regex: null,
    },
    shipzip: {
        label: 'Postal Code',
        required: false,
        regex: null,
    },    
    shipcountry: {
        label: 'Country',
        required: true,
        regex: null,        
    },    
}

const REQUIRED_ICON_RENDER = <span className="tkc-text-red">*&nbsp;</span>

export {
    FIELDS,
    REQUIRED_ICON_RENDER,
}


// WEBPACK FOOTER //
// ./src/components/billing-form/constants/fields.js